import Theme from "../theme/models/theme.model";

export enum LoginProvider {
  LEGACY = 1,
  AUTH0 = 2
}

export class Tenant {
  id: string;
  name: string;
  base_url: string;
  markets: number[];
  theme?: Theme
  login_provider: LoginProvider = LoginProvider.LEGACY;

  constructor(data: Partial<Tenant>) {
    Object.assign(this, data);
    // Missing/null login_provider (older tenants, API gaps) must fall back to legacy.
    if (this.login_provider == null) {
      this.login_provider = LoginProvider.LEGACY;
    }
  }
}